import React, { Component } from 'react';
import Rows from './../rows'
import './styles.css'
import lang from './../../../../languages/en'
import { listShipper } from './../../../../utils/shipperInfor'
import handleException from './../../../../services/handleException'
import { Spin } from 'antd'
import { shipperLocalStorage } from './../../helper'
import history from './../../../../services/history'

class ListShipper extends Component {
    constructor(props) {
        super(props)
        this.state = {
            listShipper: [],
            currentShipper: null,
            isLoading: false,
            params: {
                OrderBy: "BranchShortNameCH",
                IsDesc: true,
            }
        }
    }

    componentDidMount() {
        this.loadData()
    }

    loadData = () => {
        this.handleLoading(true)
        listShipper(this.state.params).then(res => {
            if (res.data.code === 10001) {
                let listShipper = res.data.data.Shipper
                let currentShipper = res.data.data.CurrentShipperID
                if(listShipper.length === 1 && currentShipper) {
                    history.push('/orders')
                }
                this.setState({
                    listShipper,
                    currentShipper
                }, () => {
                    this.props.handleCurrentShipper(this.state.currentShipper)
                })
                shipperLocalStorage(listShipper, currentShipper)
            } else {
                handleException(res)
            }
            this.handleLoading(false)
        }).catch(err => {
            handleException(err)
        })
    }

    handleLoading = (value) => {
        this.setState({
            isLoading: value
        })
    }

    /**
     * click head => sort table data => call api
     */
    onSort = (e, key) => {
        let isDesc;
        if (this.state.params.OrderBy === key) {
            isDesc = !this.state.params.IsDesc;
        } else {
            isDesc = true;
        }
        this.setState({
            params: {
                OrderBy: key,
                IsDesc: isDesc,
            }
        });
        setTimeout(() => {
            this.loadData();
        })
    }

    /**
     * check head is order by desc
     * @return boolean true = desc|false = asc|null = not sort
     */
    isSorting = (key) => {
        if (this.state.params.OrderBy === key) {
            return this.state.params.IsDesc;
        }
        return null;
    }

    render() {
        return (
            <div className='list-shipper'>
                <h1 className="title-page">{lang.select_shipper_switch}</h1>
                <Spin tip="Loading..." spinning={this.state.isLoading}>  
                    <table className='table-switch-shipper'>
                        <thead>
                            <tr>
                                <th onClick={e => this.onSort(e, 'BranchShortNameCH')}>
                                    <div className="warp-header sortable">
                                        <div className="title-header">
                                            Branch
                                        </div>
                                        <div className="sort-icon">
                                            <i className={"fa fa-chevron-up si-img" + (this.isSorting('BranchShortNameCH') === false ? ' sorting' : '')} aria-hidden="true" />
                                            <i className={"fa fa-chevron-down si-img" + (this.isSorting('BranchShortNameCH') === true ? ' sorting' : '')} aria-hidden="true" />
                                        </div>
                                    </div>
                                </th>
                                <th onClick={e => this.onSort(e, 'ShipperNameCH')}>
                                    <div className="warp-header sortable">
                                        <div className="title-header">
                                            Shipper
                                        </div>
                                        <div className="sort-icon">
                                            <i className={"fa fa-chevron-up si-img" + (this.isSorting('ShipperNameCH') === false ? ' sorting' : '')} aria-hidden="true" />
                                            <i className={"fa fa-chevron-down si-img" + (this.isSorting('ShipperNameCH') === true ? ' sorting' : '')} aria-hidden="true" />
                                        </div>
                                    </div>
                                </th>
                                <th onClick={e => this.onSort(e, 'Address1CH')}>
                                    <div className="warp-header sortable">
                                        <div className="title-header">
                                            Address
                                        </div>
                                        <div className="sort-icon">
                                            <i className={"fa fa-chevron-up si-img" + (this.isSorting('Address1CH') === false ? ' sorting' : '')} aria-hidden="true" />
                                            <i className={"fa fa-chevron-down si-img" + (this.isSorting('Address1CH') === true ? ' sorting' : '')} aria-hidden="true" />
                                        </div>
                                    </div>
                                </th>
                                <th>Active</th>
                            </tr>
                        </thead>
                        <Rows
                            listShipper={this.state.listShipper}
                            currentShipper={this.state.currentShipper}
                            handleLoading={this.handleLoading}
                            handleCurrentShipper={this.props.handleCurrentShipper}
                        />
                    </table>
                </Spin>
            </div>
        );
    }
}

export default ListShipper;


// WEBPACK FOOTER //
// ./src/containers/switch-shipper/components/list-shipper/index.js